import React from 'react';
import { FiExternalLink } from 'react-icons/fi';
import { useWebLocale } from '../../contexts/WebLocaleContext';
import { useColorScheme } from '../../contexts/ColorSchemeContext';
import { playlistExternalUrl } from '../../features/browse/PlaylistDetailContent';
import apple from '../../assets/streaming-services/apple-music.jpg';
import youtube from '../../assets/streaming-services/youtube-music.jpg';
import melon from '../../assets/streaming-services/melon.jpg';
import bugs from '../../assets/streaming-services/bugs.jpg';
import genie from '../../assets/streaming-services/genie.jpg';
import flo from '../../assets/streaming-services/flo.jpg';
import vibe from '../../assets/streaming-services/vibe.jpg';
import tidal from '../../assets/streaming-services/tidal.jpg';
import soundcloud from '../../assets/streaming-services/soundcloud.jpg';
import bandcamp from '../../assets/streaming-services/bandcamp.jpg';
import mixider from '../../assets/streaming-services/mixider.png';
import mixiderDark from '../../assets/streaming-services/mixider-dark.png';
const services = [
  ['spotify', ['spotify.com'], 'Spotify'],
  ['apple', ['music.apple.com'], 'Apple Music'],
  ['melon', ['kko.to', 'melon.com', 'melon.co.kr'], '멜론 뮤직', 'Melon Music'],
  ['bugs', ['bugs.co.kr'], '벅스 뮤직', 'Bugs Music'],
  ['genie', ['genie.co.kr'], '지니 뮤직', 'Genie Music'],
  ['flo', ['flomuz.io', 'music-flo.com'], 'FLO'],
  ['vibe', ['naver.me', 'vibe.naver.com'], 'NAVER VIBE'],
  ['youtube', ['youtube.com', 'youtu.be'], 'YouTube Music'],
  ['tidal', ['tidal.com'], 'TIDAL'],
  ['soundcloud', ['soundcloud.com'], 'SoundCloud'],
  ['bandcamp', ['bandcamp.com'], 'Bandcamp'],
  ['mixider', ['mixider.com'], 'Mixider'],
];
export function playlistService(value, locale = 'ko') {
  const url = playlistExternalUrl(value);
  if (!url) return null;
  const host = new URL(url).hostname.toLowerCase();
  const match = services.find(([, domains]) =>
    domains.some((d) => host === d || host.endsWith('.' + d)),
  );
  return {
    url,
    kind: match?.[0] || 'external',
    label: match
      ? locale === 'en'
        ? match[3] || match[2]
        : match[2]
      : locale === 'en'
        ? 'External Music Service'
        : '외부 음악 서비스',
  };
}
export default function PlaylistExternalLink({ url }) {
  const { locale } = useWebLocale(),
    { resolvedMode } = useColorScheme();
  const service = playlistService(url, locale);
  if (!service) return null;
  const icons = {
    apple,
    youtube,
    melon,
    bugs,
    genie,
    flo,
    vibe,
    tidal,
    soundcloud,
    bandcamp,
    mixider: resolvedMode === 'dark' ? mixiderDark : mixider,
  };
  return (
    <a
      className="pp-playlist-external"
      href={service.url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={
        locale === 'en' ? `Open playlist in ${service.label}` : `${service.label}에서 플리 열기`
      }
    >
      <span className="pp-playlist-service-logo" data-service={service.kind}>
        {icons[service.kind] ? (
          <img src={icons[service.kind]} alt="" />
        ) : service.kind === 'spotify' ? (
          <svg viewBox="0 0 34 34" aria-hidden="true">
            <circle cx="17" cy="17" r="17" fill="#1ED760" />
            <path
              d="M8.2 13.1c5.9-1.7 12.9-1.3 18.1 1.3M9.4 17.5c5.1-1.3 11.2-.9 15.8 1.2M10.5 21.5c4.3-1 9.4-.7 13.3 1"
              fill="none"
              stroke="#111"
              strokeWidth="2.5"
              strokeLinecap="round"
            />
          </svg>
        ) : (
          <FiExternalLink size={18} />
        )}
      </span>
      <span className="pp-playlist-service-copy">
        <strong>{locale === 'en' ? 'Listen on Another Service' : '다른 서비스에서 듣기'}</strong>
        <span>{locale === 'en' ? `Open in ${service.label}` : `${service.label}에서 열기`}</span>
      </span>
      <FiExternalLink size={18} />
    </a>
  );
}
